export enum GfhAccountStatus {
  Active = 0,
  Canceled = 1,
  WaitingForTransactions = 2,
  Closed = 3,
  WaitingForApproval = 4,
  PausedDuringDisbursement = 5,
  WaitingForIdentification = 6,
}
